<template>
  <div>
    <component
      class="card-detail"
      v-for="item in items"
      :is="editingItemId === item.id ? getFormComponent(item) : getComponent(item)"
      :patient-id="patientId"
      :record-id="item.recordId || id"
      :exam-id="item.id"
      :data="editingItemId === item.id ? item : item.inputs"
      :date="item.date"
      :title="item.title"
      :medical-record-id="item.recordId || id"
      :patient="{ id: patientId }"
      :key="item.id"
      :show-edit-button="showEditButton"
      @edit="startEdit(item.id)"
      @save="onSave"
      @cancel="cancelEdit"
      @remove="$emit('refresh')"
    />
  </div>
</template>

<script>
import { exams } from './data';
import DefaultView from './DefaultView.vue';

export default {
  props: ['items', 'patientId', 'id', 'showEditButton'],
  data() {
    return {
      editingItemId: null,
    };
  },
  methods: {
    getComponent({ templateRenderer }) {
      if (templateRenderer) {
        const exam = exams.find(({ key }) => key === templateRenderer);
        if (exam && exam.view) {
          return exam.view;
        }
      }
      return DefaultView;
    },
    getFormComponent({ templateRenderer }) {
      if (templateRenderer) {
        const exam = exams.find(({ key }) => key === templateRenderer);
        if (exam && exam.form) {
          return exam.form;
        }
      }
      return null;
    },
    startEdit(itemId) {
      this.editingItemId = itemId;
    },
    cancelEdit() {
      this.editingItemId = null;
    },
    onSave() {
      this.editingItemId = null;
      this.$emit('refresh');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

.medical-record-exam-view {
  .eye-detail-card {
    background-color: $gray-color-light;
    border: $border-width solid $gray-color-light;
    border-radius: $border-radius;
    padding: 0;
  }
  .eye-detail-card-header,
  .eye-detail-card-value-row {
    padding: $layout-spacing-sm $layout-spacing;
    text-align: left;
    & > div:first-child {
      color: $gray-color-dark;
      flex: 0 0 33%;
    }
  }
  .eye-detail-card-value-row {
    border-top: $border-width solid $gray-color-ultra-light;
  }
  .additional-info {
    padding: $layout-spacing-sm;

    h5 {
      color: $gray-color;
      font-size: $font-size-sm;
      text-transform: uppercase;
    }

    p {
      margin: 0;
      color: $dark-color;
    }

    .mb-1 {
      margin-bottom: 0.25rem;
    }
  }
}
</style>
